import { render, staticRenderFns } from "./Pendencia.vue?vue&type=template&id=a03f1cb8&scoped=true"
import script from "./Pendencia.vue?vue&type=script&lang=js"
export * from "./Pendencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03f1cb8",
  null
  
)

export default component.exports